import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { UserForm } from '~/components/Admin';
import { BSModal } from '~/components/Bootstrap';

function CreateUserModal() {
    const formId = 'user-create-form';
    const [show, setShow] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);

    return (
        <>
            <Button variant="primary" onClick={() => setShow(true)}>
                <i className="fa-solid fa-plus" /> New User
            </Button>
            <BSModal
                className="create-user-modal"
                show={show}
                onHide={() => setShow(false)}
                aria-labelledby="add-user-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="add-user-title" role="heading" aria-level={1}>
                        Add User
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserForm
                        formId={formId}
                        submitting={submitting}
                        setSubmitting={setSubmitting}
                        setShow={setShow}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-secondary"
                        type="button"
                        onClick={() => setShow(false)}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        form={formId}
                        disabled={submitting}
                        className="btn btn-primary"
                    >
                        {submitting && (
                            <Spinner
                                animation="border"
                                variant="light"
                                size="sm"
                                role="status"
                                className="me-1"
                            />
                        )}
                        Submit
                    </button>
                </Modal.Footer>
            </BSModal>
        </>
    );
}

export { CreateUserModal };
